import { apiClient } from "lib/apiClient";
import { IMarketAreasInfo, MarketAreaStatus } from "features/MarketAreas/types";
import { SORT_DIRECTIONS_ENUM } from "config/constants";

export interface IGetMarketAreasParams {
  status?: MarketAreaStatus;
  name?: string;
  propertyIds?: string[];
  sortField?: string | null;
  sortOrder?: SORT_DIRECTIONS_ENUM | null;
  includePropertyAssign?: boolean;
}

export const getMarketAreas = async (
  params: IGetMarketAreasParams = {},
  signal?: AbortSignal
): Promise<IMarketAreasInfo> => {
  const {
    status,
    name,
    propertyIds,
    sortField,
    sortOrder,
    includePropertyAssign,
  } = params;
  const sort = sortField
    ? `${sortField},${sortOrder ?? SORT_DIRECTIONS_ENUM.DESC}`
    : undefined;

  const response = await apiClient.get<IMarketAreasInfo>("/market-areas", {
    params: {
      status,
      name,
      propertyIds,
      sort,
      includePropertyCount: true,
      includePropertyAssign,
    },
    paramsSerializer: { indexes: null },
    signal,
  });

  return response.data;
};
